module.exports = __webpack_public_path__ + "img/member-3.0d5c7932.png";